import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Icon, Popup, Table } from 'semantic-ui-react'

import * as styles from './styles'

class TableHeaderCell extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    handleSort: PropTypes.func,
    icon: PropTypes.string.isRequired,
    id: PropTypes.string,
    sortOrder: PropTypes.string,
    sorting: PropTypes.bool,
    text: PropTypes.string.isRequired,
  }

  static defaultProps = {
    disabled: false,
    handleSort: null,
    id: null,
    sortOrder: null,
    sorting: false,
  }

  handleSort = () => {
    const { id, handleSort } = this.props

    handleSort(id)
  }

  render() {
    const { disabled, icon, sortOrder, sorting, text } = this.props

    return (
      <Table.HeaderCell
        disabled={disabled}
        onClick={!disabled && this.handleSort ? this.handleSort : null}
        sorted={sorting ? sortOrder : null}
        style={styles.headerCell}
      >
        <Popup content={text} size="mini" trigger={<Icon name={icon} />} />
      </Table.HeaderCell>
    )
  }
}

export default TableHeaderCell
